$(document).ready(function () {
  if ($('.single-page-project').length > 0) {
    const anchor = window.location.hash;
    const tab = $('.nav-tabs li a[href="' + anchor + '"]');

    if (tab.length > 0) {
      const offset = tab.offset().top - $('nav.navbar').height();

      tab.tab('show');
      $('html, body').animate({scrollTop: offset}, 1000)
    }
  }
});
